import React from 'react';
import { connect, ResolveThunks } from 'react-redux';

import { isTruss, MovingLoadSettings } from '@paragon/contract-library';
import { PropertiesPanel, PropertiesSubpanel } from '@paragon/layout-models';

import { RootState } from '../../../../store';
import { finishInsertingMovingLoadSettings } from '../../../../store/actions/insertActions';
import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { MovingLoadProperties } from '../properties/MovingLoadProperties';
import InsertionPanelContainer from './InsertionPanelContainer';

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ResolveThunks<typeof actionCreators>;
type Props = StateProps & DispatchProps;

class MovingLoadSettingsInsertion extends React.Component<Props, MovingLoadSettings> {
  readonly state: MovingLoadSettings = {
    guid: crypto.randomUUID(),
    loadDistribution: 'Concentrated',
    loadMagnitude: 0,
    magnitudeUnit: 'Pounds',
    distributedLoadLength: 0,
    startLocationX: 0,
    endLocationX: 0,
    distanceBetweenLoads: 0,
    usePanelPoints: true,
    loadType: 'Dead',
    alongMemberType: 'TopChord',
    name: null,
  };

  render() {
    const { componentDesign, insertionInfo } = this.props;
    if (insertionInfo === null || !componentDesign) return null;
    const { component } = componentDesign;
    if (!isTruss(component)) return null;

    return (
      <InsertionPanelContainer onInsert={() => this.props.finishInsertingMovingLoadSettings(this.state)}>
        <PropertiesPanel title="Define Moving Load">
          <PropertiesSubpanel title="Define Load">
            <MovingLoadProperties
              movingLoadSettings={this.state}
              trussSpacing={component.spacing}
              onChange={(movingLoadSettings) => this.setState(movingLoadSettings)}
            />
          </PropertiesSubpanel>
        </PropertiesPanel>
      </InsertionPanelContainer>
    );
  }
}

const mapStateToProps = (state: RootState) => {
  let { insertingObjectInfo } = state.application;
  if (insertingObjectInfo && insertingObjectInfo.type !== 'movingLoadSettings') {
    insertingObjectInfo = null;
  }

  return {
    insertionInfo: insertingObjectInfo,
    componentDesign: getActiveComponentDesign(state),
  };
};

const actionCreators = {
  finishInsertingMovingLoadSettings,
};

export default connect(mapStateToProps, actionCreators)(MovingLoadSettingsInsertion);
